/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_HeadlineInputs */



/**
* | output |
* | --- |
* | "Thorough proofreading and copy-editing, by the rules." |
*
* @param {Landing_HeadlineInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const landing_headline = /** @type {((inputs?: Landing_HeadlineInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_HeadlineInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Thorough proofreading and copy-editing, by the rules.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Grundlig korrektur och språkgranskning, enligt reglerna.")
	return /** @type {LocalizedString} */ ("Grundig korrektur og språkvask, etter reglene.")
});